module.exports = __webpack_public_path__ + "img/Trägerstruktur4.fbcfbcb3.jpg";